import { AfterViewInit, Component, computed, effect, EventEmitter, inject, Input, OnDestroy, OnInit, TemplateRef, viewChild } from '@angular/core';

import { IPageData } from 'src/app/infrastructure/services/page-services/models/page-data';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { FooterService } from '../../../footer/footer.service';
import { SharedModule } from '../../../shared.module';
import { FooterComponent } from '../../../footer/container/footer.component';
import { ButtonNavigationComponent } from '../../../controls/container/button-navigation/button-navigation.component';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { LoadingHeaderService } from 'src/app/infrastructure/services/loading-services/loading-header.service';
import { PageLockService } from 'src/app/infrastructure/services/loading-services/page-lock.service';
import { loadKey } from 'src/app/infrastructure/services/loading-services/models/loadKey';
import { pageTransitionAnimation } from 'src/app/infrastructure/animations/route-animations';
import { _CentralPageService } from '../../services/_central-page.service';
import { IButtonData } from '../../../controls/models/_base-button';
import { NgTemplateOutlet } from '@angular/common';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Component({
    selector: 'app-composite-component',
    templateUrl: './composite.component.html',
    styleUrls: [
        '../../central-page.scss',
        './composite.component.scss',
    ],
    host: {
        'class': 'composite-component'
    },
    standalone: true,
    imports: [
        ButtonNavigationComponent,
        NgTemplateOutlet,
        SharedModule,
        FooterComponent,
    ],
    animations: [
        pageTransitionAnimation,
    ]
})
export class CompositePageComponent
    implements AfterViewInit, OnInit, OnDestroy
{
    protected readonly _footerService = injectRequired(FooterService);
    protected readonly _centralPageService = injectRequired(_CentralPageService);
    protected readonly _loadingPageService = injectRequired(LoadingPageService);
    protected readonly _loadingHeaderService = injectRequired(LoadingHeaderService);
    protected readonly _pageLockService = injectRequired(PageLockService);
    protected readonly _pageService = injectRequired(_PageService);

    readonly loadKey = loadKey;

    returnPage$$ = this._pageService?.pageReturn$$;
    displayName$$ = computed(() => this.returnPage$$()?.displayName);

    loadingPage$$ = this._loadingPageService.isLoading$$;
    // Page-lock (ook door een screen-lock verhoogd): overlay over de content + spinner.
    locked$$ = this._pageLockService.locked$$;

    logging = true;
    returnPage: IPageData | null = null;
    templatesListButtons: TemplateRef<any>[] | null = null;

    // get ReturnPage() {return this._pageService.ReturnPage}

    @Input() template_page: TemplateRef<any> | null = null;

    emitDestroyed = new EventEmitter();

    template_footerLeft$$ = viewChild<TemplateRef<any>>('template_footerLeft');

    constructor(
    ){
        effect(() => this._footerService.template_buttonLeft_set(this.template_footerLeft$$()));
    }

    ngOnInit(): void {
        this.returnPage = this._pageService?.pageReturn$$();
    }

    emit_dirtyForm(value: boolean): void {
        // this.sectionEdit_buttonSave_data = this.button_disable(this.sectionEdit_buttonSave_data, !value);
    }

    // Via pageReturn_goto (niet page_goto): die kent de terugval op de startpagina wanneer er geen
    // frame onder het huidige ligt. Rechtstreeks page_goto liet de knop bij een lege stack niets doen
    // behalve een waarschuwing loggen.
    emit_esc() {
        this._pageService.pageReturn_goto();
    }

    emit_onClickReturn() {
        this._pageService.pageReturn_goto();
    }

    emit_onClickSave() {
        // this.saveOnClick = true;
    }

    // protected emit_pageLoaded() {
    //     this._pageService.page_removeLoading();
    // }

    protected button_disable(btnData: IButtonData, disable: boolean) {
        btnData.disabled = disable;
        return btnData;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this._loadingHeaderService.clear();
        }, 0);
    }

    ngOnDestroy(): void {
        this.emitDestroyed.emit();     // used in takeUntil(), otherwise subscription won't be destroyed
        this.emitDestroyed.unsubscribe();
    }
}
